$(document).ready(function () {
    if ($("#wrapper-game").hasClass("-opera")) {
        $("main#main-content").addClass("-opera");
    }
    else if ($("#wrapper-game").hasClass("-fdm")) {
        $("main#main-content").addClass("-fdm");
    }
    else if ($("#wrapper-game").hasClass("-st-val")) {
        $("main#main-content").addClass("-st-val");
    }
    else if ($("#wrapper-game").hasClass("-fdgm")) {
        $("main#main-content").addClass("-fdgm");
    }
    else if ($("#wrapper-game").hasClass("-fdm2024")) {
        $("main#main-content").addClass("-fdm2024");
    }
})